import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function Footer() {
  const { user } = useAuth()
  const [role, setRole] = useState(null)

  useEffect(() => {
    const fetchRole = async () => {
      if (!user) return
      const { data } = await supabase
        .from('supporters').select('role').eq('id', user.id).single()
      if (data) setRole(data.role)
    }
    fetchRole()
  }, [user])

  const linkClass = "text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white text-sm transition-colors"

  const renderLinks = () => {
    // Visitor
    if (!user) return (
      <div>
        <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-4">Platform</div>
        <div className="flex flex-col gap-3">
          <Link to="/register" className={linkClass}>Register</Link>
          <Link to="/login" className={linkClass}>Sign In</Link>
          <Link to="/fixtures" className={linkClass}>Fixtures</Link>
          <Link to="/welfare" className={linkClass}>Welfare</Link>
        </div>
      </div>
    )

    // Supporter
    if (role === 'supporter') return (
      <>
        <div>
          <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-4">Platform</div>
          <div className="flex flex-col gap-3">
            <Link to="/dashboard" className={linkClass}>Dashboard</Link>
            <Link to="/fixtures" className={linkClass}>Fixtures</Link>
            <Link to="/welfare" className={linkClass}>Welfare</Link>
            <Link to="/membership-card" className={linkClass}>My Card</Link>
          </div>
        </div>
        <div>
          <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-4">Account</div>
          <div className="flex flex-col gap-3">
            <Link to="/profile" className={linkClass}>Profile</Link>
            <Link to="/subscribe" className={linkClass}>Subscription</Link>
          </div>
        </div>
      </>
    )

    // Coordinator
    if (role === 'chapter_coordinator') return (
      <div>
        <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-4">Portal</div>
        <div className="flex flex-col gap-3">
          <Link to="/coordinator" className={linkClass}>Overview</Link>
          <Link to="/coordinator/members" className={linkClass}>Members</Link>
          <Link to="/admin/scan" className={linkClass}>Scan Card</Link>
        </div>
      </div>
    )

    // Club Admin
    if (role === 'club_admin') return (
      <div>
        <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-4">Admin Portal</div>
        <div className="flex flex-col gap-3">
          <Link to="/admin" className={linkClass}>Overview</Link>
          <Link to="/admin/members" className={linkClass}>Members</Link>
          <Link to="/admin/subscriptions" className={linkClass}>Subscriptions</Link>
          <Link to="/admin/fixtures" className={linkClass}>Fixtures</Link>
        </div>
      </div>
    )

    // Super Admin
    if (role === 'super_admin') return (
      <div>
        <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-4">Super Admin</div>
        <div className="flex flex-col gap-3">
          <Link to="/superadmin" className={linkClass}>Overview</Link>
          <Link to="/superadmin/members" className={linkClass}>Members</Link>
          <Link to="/superadmin/clubs" className={linkClass}>Clubs</Link>
          <Link to="/superadmin/invite" className={linkClass}>Invite Admin</Link>
        </div>
      </div>
    )

    return null
  }

  return (
    <footer className="bg-white dark:bg-black border-t border-gray-200 dark:border-white/10 px-8 py-12 mt-auto">
      <div className="max-w-6xl mx-auto">

        <div className="flex flex-col lg:flex-row justify-between gap-10 mb-12">

          {/* Brand */}
          <div className="max-w-xs">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src="/Mufulira_Wanderers_logo.png" alt="Mufulira Wanderers" className="w-8 h-8 object-contain" />
              <span className="font-black text-gray-900 dark:text-white tracking-widest uppercase">MWFC</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed">
              The digital platform connecting football supporters, clubs, and communities across the Globe.
            </p>
          </div>

          {/* Links */}
          <div className="flex gap-16 flex-wrap">
            {renderLinks()}
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-white/10 pt-8 flex flex-col lg:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-xs uppercase tracking-widest">
            © {new Date().getFullYear()} MWSS. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/policies" className="text-gray-400 hover:text-gray-900 dark:hover:text-white text-xs uppercase tracking-widest transition-colors">
              Refund & Cancellation Policy
            </Link>
            <p className="text-gray-400 text-xs uppercase tracking-widest">
              Built for African Football Communities
            </p>
          </div>
        </div>

      </div>
    </footer>
  )
}
